module.exports = __webpack_public_path__ + "static/img/KH@2x.282a8b58.jpg";